import React from "react";

import InputLabel from "@material-ui/core/InputLabel";

import useRbInputLabelStyles from "./useRbInputLabelStyles";

function RbInputLabel(props) {
  const classes = useRbInputLabelStyles();

  return <InputLabel {...props} classes={classes} />;
}

export default React.memo(RbInputLabel);
